export default "mutation createTeachUnit($create: TeachUnitCreateRequest) {\n  createTeachUnit(create: $create) {\n\t\t_ALL_\n\t}\n}";